<script>
    import {fade} from 'svelte/transition';
    import {
        elementInstance,
        branchId,
        elementDetails,
        loadingElementDetails,
        standaloneEdit
    } from './workspacesStore.js';
    import ElementDetails from './ElementView/ElementDetails.svelte';
    import KeyPointTable from './ElementView/KeyPointTable.svelte';
    import QuestionsTable from './ElementView/QuestionsTable.svelte';
    import RisksAndControls from '../Element/RisksAndControls/RisksAndControls.svelte';
    import ToolTable from './ElementView/ToolTable.svelte';
    import PartTable from './ElementView/PartTable.svelte';
    import MaterialRisk from './ElementView/MaterialRisk.svelte';
    import Messages from '../common/Messages.svelte';
    import {sgettext} from '../../i18n';
    import ReferenceDocumentTable from "./ElementView/ReferenceDocumentTable.svelte";
    import Section from '../common/Section.svelte';
    import AssetExecutionDetails from '../Element/AssetExecutionDetails.svelte';
    import CorrectiveAction from '../Element/CorrectiveAction.svelte';

    export let workspaceReadOnly = false;

    // squash unknown prop warnings
    export let key;
    export let label;
    export let active;
    export let content;
    export let hide;

    let showWarning = false;
    let showMaterialRisk = false;

    $: showWarning = $elementDetails && $elementDetails.warnings && $elementDetails.warnings.length;
    $: showMaterialRisk = $elementDetails && $elementDetails.materialRisk && $elementDetails.type === 'SAFETY';
</script>

{#if !$loadingElementDetails && $elementDetails}
  {#if (!$standaloneEdit && $elementInstance && $elementInstance.versions.length === 1 && $elementInstance.versions[0].status.toLowerCase() === 'draft') || ($standaloneEdit && $elementDetails && $elementDetails.status.toLowerCase() === 'draft')}
    <div>
      {sgettext('$$CURRENT_VERSION_NOT_AVAILABLE_PLEASE$$')}
    </div>
  {:else}
    <div transition:fade|local class="wrapper">
      {#if showWarning}
        <Messages type="warning" text={$elementDetails.warnings} />
      {/if}
      {#if showMaterialRisk}
        <MaterialRisk
          mechanism={$elementDetails.materialRisk.mechanism}
          hazard={$elementDetails.materialRisk.hazard}
          control={$elementDetails.materialRisk.control}
          valid={$elementDetails.materialRisk.valid}
        />
      {/if}
      <ElementDetails details={$elementDetails} {workspaceReadOnly} />
      <Section title={sgettext('$$RISKS_CONTROLS_1$$')}>
        <RisksAndControls rows={$elementDetails.hazardscontrols} />
      </Section>
      {#if $elementDetails.type === 'PART'}
        <Section title={sgettext('$$PARTS$$')}>
          <PartTable rows={$elementDetails.parts} />
        </Section>
      {/if}
      {#if $elementDetails.type === 'QUALITY' || $elementDetails.type === 'SAFETY' || $elementDetails.type === 'KNACK'}
        <Section title={sgettext('$$KEY_POINTS$$')}>
          <KeyPointTable rows={$elementDetails.keypoints} />
        </Section>
      {/if}
      {#if $elementDetails.type === 'QUALITY' || $elementDetails.type === 'SAFETY'}
        <Section title={sgettext('$$QUESTIONS$$')}>
          <QuestionsTable rows={$elementDetails.questions} />
        </Section>
      {/if}

      {#if !$standaloneEdit}
        <Section title={sgettext('$$ASSET_EXECUTION_DETAILS$$')}>
          <AssetExecutionDetails
            model={$elementDetails}
            showEditLinks={!workspaceReadOnly &&
              !$elementDetails?.element_from_apm}
          />
        </Section>
      {/if}

      <Section title={sgettext('$$CORRECTIVE_ACTION$$')}>
        <CorrectiveAction model={$elementDetails} />
      </Section>

      {#if $elementDetails.type === 'TOOL'}
        <Section title={sgettext('$$TOOLS$$')}>
          <ToolTable rows={$elementDetails.tools} />
        </Section>
      {/if}
      <Section title={sgettext('$$REFERENCE_DOCUMENTS$$')}>
        <ReferenceDocumentTable rows={$elementDetails.reference_documents} />
      </Section>
    </div>
  {/if}
{/if}

<style>
  .wrapper {
    display: flex;
    flex-direction: column;
  }

  .wrapper > section {
    min-height: 80px;
    margin: 15px 5px;
  }
</style>
